import { Linking, StyleSheet, View } from "react-native"
import { Tiny } from "@/components/standard/BFText"

interface MarketDataLegalTextProps {
  provider?: string
  asOfDate?: string
  startDate?: string
  endDate?: string
}

export const emptyPlaceholder: string = "---"

const MarketDataLegalText: React.FC<MarketDataLegalTextProps> = ({
  provider = "Redfin",
  asOfDate = "N/A",
  startDate = "N/A",
  endDate = "N/A",
}: MarketDataLegalTextProps) => {
  const handlePress = () => {
    void Linking.openURL("https://www.redfin.com")
  }

  return (
    <View className="m-1 items-center justify-center ios:mt-[-16px] android:mt-[-16px] web:mt-1 w-full">
      <Tiny className="text-white pl-1 web:w-[354px]">
        Data provided by{" "}
        <Tiny style={styles.linkText} onPress={handlePress}>
          {provider}
        </Tiny>
        {`, a national real estate brokerage as of ${asOfDate}. Date range ${startDate} - ${endDate}`}
      </Tiny>
    </View>
  )
}

const styles = StyleSheet.create({
  linkText: {
    textDecorationLine: "underline",
  },
})

export default MarketDataLegalText
